<template>
  <!-- Completed and closed projects are read-only until they are reopened -->
  <div v-if="locked" class="project-locked" data-qid="project-locked-notice">
    <font-awesome-icon :icon="project.status === 'closed' ? 'archive' : 'lock'" class="project-locked__icon"/>
    <div>
      <div class="project-locked__title">{{ project.status === 'closed' ? $t('projects.locked.title_closed') : $t('projects.locked.title_completed') }}</div>
      <div class="project-locked__message">
        {{ $t('projects.locked.message') }}
        <span v-if="project.control_type === 'one time'">{{ $t('projects.locked.reopen_hint') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectLockedNotice',
  props: {
    project: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    locked() {
      return !!this.project && (this.project.status === 'completed' || this.project.status === 'closed');
    }
  }
}
</script>
